const StoryHook = () => {
  return (
    <section className="py-32 relative overflow-hidden">
      {/* Ambient effects */}
      <div className="absolute inset-0 bg-noise opacity-20" />
      <div className="absolute top-1/3 right-0 w-1 h-48 bg-gradient-to-b from-transparent via-primary/50 to-transparent" />
      <div className="absolute bottom-1/3 left-0 w-1 h-48 bg-gradient-to-b from-transparent via-[hsl(var(--burgundy))]/50 to-transparent" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-10 text-center animate-fade-in">
            <div className="pt-8">
              <p className="text-3xl md:text-4xl font-playfair text-foreground italic leading-relaxed">
                There's a difference between safety and captivity.
              </p>
              <p className="text-2xl md:text-3xl font-brush text-primary mt-4 drop-shadow-[0_0_20px_hsl(var(--primary)/0.5)]">
                She just can't remember which she wanted more.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoryHook;
